import React from 'react';
import { MultipleAuthorTemplate } from '../multi-author';
import { getAuthorNameKeyword, getDevider } from '../utils';

import './photo-low-priority-multi-author.m.css';

export function PhotoLowPriorityMultiAuthorTemplate(props) {
  const lowPhotoPriorityPropsObj = Object.assign({}, props, {
    authorNameKeyword: getAuthorNameKeyword(),
    storyPubKeyword: getDevider(),
    hideImage: true
  });

  return <div styleName="low-photo-priority-multi-author">
    <MultipleAuthorTemplate  {...lowPhotoPriorityPropsObj} />
  </div>;
}